/** ₹ with Indian digit grouping, up to 2 decimals. One implementation so the
 *  same amount never renders two different ways across earnings surfaces. */
export const formatInr = (value: number): string =>
  `${value < 0 ? "-" : ""}₹${Math.abs(value).toLocaleString("en-IN", {
    maximumFractionDigits: 2,
  })}`;

export default { formatInr };
